import { apiClient } from "../client";
import { ApiErrorHandler } from "../utils/error-handler";

/**
 * Endpoints de autenticação
 * 
 * Funcionalidades:
 * - Login de usuário
 * - Refresh de token
 * - Logout
 * - Validação de token
 */

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  access: string;
  refresh: string;
  user: {
    id: number;
    username: string;
    email: string;
  };
}

export interface RefreshRequest {
  refresh: string;
}

export interface RefreshResponse {
  access: string;
}

export const authApi = {
  /**
   * Login de usuário
   */
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    try {
      const response = await apiClient.post("/auth/login/", credentials, {
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      ApiErrorHandler.handleRequestError(error, "AuthAPI.login");
    }
  },

  /**
   * Refresh de token
   */
  refreshToken: async (refreshToken?: string): Promise<RefreshResponse> => {
    try {
      const payload = refreshToken ? { refresh: refreshToken } : {};
      const response = await apiClient.post("/auth/refresh/", payload, {
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      ApiErrorHandler.handleRequestError(error, "AuthAPI.refreshToken");
    }
  },

  /**
   * Logout de usuário
   */
  logout: async (): Promise<void> => {
    try {
      await apiClient.post("/auth/logout/", {}, {
        withCredentials: true,
        headers: { "Content-Type": "application/json" },
      });
      // Limpar token local
      localStorage.removeItem("access_token");
    } catch (error) {
      // Mesmo com erro, limpar token local
      localStorage.removeItem("access_token");
      ApiErrorHandler.handleRequestError(error, "AuthAPI.logout");
    }
  },

  /**
   * Verificar se o usuário está autenticado
   */
  isAuthenticated: (): boolean => {
    const token = localStorage.getItem("access_token");
    return !!token;
  },

  /**
   * Obter token atual
   */
  getToken: (): string | null => {
    return localStorage.getItem("access_token");
  },

  /**
   * Definir token
   */
  setToken: (token: string): void => {
    localStorage.setItem("access_token", token);
  },

  /**
   * Remover token
   */
  removeToken: (): void => {
    localStorage.removeItem("access_token");
  },
}; 